import configuration from './../config.json'
import reportService from '../shared/services/reportService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const REQUEST_REPORT_FORMATS = 'REQUEST_REPORT_FORMATS'
const RESPONSE_REPORT_FORMATS = 'RESPONSE_REPORT_FORMATS'
const REQUEST_REPORT_FORMATS_FAILURE = 'REQUEST_REPORT_FORMATS_FAILURE'

const requestReportFormatsAction = () => {
  return {
    type: REQUEST_REPORT_FORMATS
  }
}

const responseReportFormatsAction = data => {
  return {
    type: RESPONSE_REPORT_FORMATS,
    data
  }
}

const requestReportFormatsFailureAction = errors => {
  return {
    type: REQUEST_REPORT_FORMATS_FAILURE,
    errors
  }
}

const getReportFormats = () => {
  return (dispatch) => {
    dispatch(requestReportFormatsAction())
    dispatch(responseReportFormatsAction([0]))
   /*  reportService.getReportFormats()
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)
        
        dispatch(responseReportFormatsAction(result.data))
      })
      .catch((error) => {
        dispatch(requestReportFormatsFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })*/
  } 
}

export {
  getReportFormats,
  requestReportFormatsAction,
  responseReportFormatsAction,
  requestReportFormatsFailureAction,
  REQUEST_REPORT_FORMATS,
  RESPONSE_REPORT_FORMATS,
  REQUEST_REPORT_FORMATS_FAILURE
}